import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { useGetOrganisation } from "@/features/organisations/api/get-organisation";
import { ReplaySettingForm } from "@/features/recording-comments/components/replay-setting.form";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";

export function ReplayPage() {
  const { organisation } = useOrganisation();
  const { data, isLoading, isSuccess, isError, error } = useGetOrganisation({
    id: organisation.id,
  });

  if (isLoading)
    return (
      <div>
        <OnboardingHeader
          title="Replay Settings"
          description="Manage default replay behaviour"
          className="mb-6"
        />
        <LoadingScreen />
      </div>
    );

  if (isError || !isSuccess)
    return (
      <div>
        <OnboardingHeader
          title="Replay Settings"
          description="Manage default replay behaviour"
          className="mb-6"
        />
        <ErrorMessage error={error} />
      </div>
    );

  return (
    <div>
      <OnboardingHeader
        title="Replay Settings"
        description="Manage default replay behaviour"
        className="mb-6"
      />
      <ReplaySettingForm initialData={data} />
    </div>
  );
}
